"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=["ctrlKey","metaKey","altKey","shiftKey"];exports.isModifiedClickEvent=t=>e.some((e=>e in t&&t[e]));
//# sourceMappingURL=is-modified-click-event.js.map
